import type { SurveyTriggerEventDetail } from './types';

const EVENT_NAME = 'survey:trigger';

class SurveyEventBus extends EventTarget {
  private subscriberCount = 0;

  dispatch(detail: SurveyTriggerEventDetail) {
    // Without an active host (e.g. role-gated route, host not yet mounted)
    // dispatching would leave the caller's promise pending forever.
    if (this.subscriberCount === 0) {
      detail.resolve(false);
      return;
    }
    this.dispatchEvent(new CustomEvent<SurveyTriggerEventDetail>(EVENT_NAME, { detail }));
  }

  subscribe(handler: (detail: SurveyTriggerEventDetail) => void): () => void {
    const listener = (event: Event) => {
      handler((event as CustomEvent<SurveyTriggerEventDetail>).detail);
    };
    this.addEventListener(EVENT_NAME, listener);
    this.subscriberCount += 1;
    let active = true;
    return () => {
      if (!active) return;
      active = false;
      this.removeEventListener(EVENT_NAME, listener);
      this.subscriberCount -= 1;
    };
  }
}

export const surveyEventBus = new SurveyEventBus();
